import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import { IGateMark } from './interfaces';
import { IAvailableColumnModel, IAvailableGroupColumnModel } from 'interfaces';

export const getGateMarkList = (params: IDynamicTableParams): Promise<IGateMark[]> => {
  return instance()
    .post('/calculatorTariff/gateMark/list', params)
    .then((response) => response.data);
};

export const getGateMarkListAll = (): Promise<IGateMark[]> => {
  return instance()
    .post('/calculatorTariff/gateMark/listAll')
    .then((response) => response.data);
};

export const getGateMarkAvailableColumns = (): Promise<IAvailableColumnModel[]> => {
  return instance()
    .post('/calculatorTariff/gateMark/availableColumns')
    .then((response) => response.data);
};

export const getGateMarkAvailableGroupColumns = (): Promise<IAvailableGroupColumnModel[]> => {
  return instance()
    .post('/calculatorTariff/gateMark/availableGroupColumns')
    .then((response) => response.data);
};

export const loadGateMark = (gateMarkId: number) => {
  return instance()
    .get<IGateMark>('/calculatorTariff/gateMark/load/' + gateMarkId)
    .then((response) => response.data);
};

export const createGateMark = (gateMark: IGateMark) => {
  return instance()
    .post<IGateMark>('/calculatorTariff/gateMark/save', gateMark)
    .then((response) => response.data);
};

export const updateGateMark = (gateMark: IGateMark) => {
  return instance()
    .post<IGateMark>(`/calculatorTariff/gateMark/${gateMark.gateMarkId}/update`, gateMark)
    .then((response) => response.data);
};

export const deleteGateMark = (gateMarkId: number) => {
  return instance()
    .post('/calculatorTariff/gateMark/archive', { gateMarkId })
    .then((response) => response.data);
};

export const recoverGateMark = (gateMarkId: number) => {
  return instance()
    .post('/calculatorTariff/gateMark/recover', { gateMarkId })
    .then((response) => response.data);
};
